import React from "react";
import { MultiSelect, MultiSelectOption } from "@utahdts/utah-design-system";

const SectionConditionIndicatorFilter = ({
  id,
  label,
  indicatorTypes,
  indicators,
  onIndicatorsChange,
  canEdit,
}) => {
  const handleIndicatorNamesChange = (indicatorNames) => {
    onIndicatorsChange(
      indicatorNames.map(
        (indicatorName) =>
          indicators.find((indicator) => indicator.indicatorName === indicatorName) ?? { indicatorName, indicatorValues: [] }
      )
    );
  };

  const handleIndicatorValuesChange = (indicatorName, indicatorValues) => {
    onIndicatorsChange(
      indicators.map((indicator) =>
        indicator.indicatorName === indicatorName ? { ...indicator, indicatorValues } : indicator
      )
    );
  };

  return (
    <div className="site-visits-option-fields-grid">
      <div>
        <MultiSelect
          id={id}
          isClearable
          isDisabled={!canEdit}
          label={label}
          values={indicators.map((indicator) => indicator.indicatorName)}
          onChange={handleIndicatorNamesChange}
          className="site-visits-field-control"
          portalTarget={document.body}
        >
          {indicatorTypes.map((indicatorType) => (
            <MultiSelectOption
              key={indicatorType.code}
              label={`${indicatorType.code} - ${indicatorType.description}`}
              searchValue={indicatorType.code}
              value={indicatorType.code}
            />
          ))}
        </MultiSelect>
      </div>
      {indicators.map((indicator) => {
        const valueOptions = indicatorTypes.find((indicatorType) => indicatorType.code === indicator.indicatorName)?.values ?? [];
        if (valueOptions.length === 0 && indicator.indicatorValues.length === 0) return null;

        return (
          <div key={indicator.indicatorName} className="site-visits-nested-field">
            <MultiSelect
              id={`${id}-${indicator.indicatorName}-values`}
              isClearable
              isDisabled={!canEdit}
              label={`${indicator.indicatorName} Values`}
              values={indicator.indicatorValues}
              onChange={(indicatorValues) => handleIndicatorValuesChange(indicator.indicatorName, indicatorValues)}
              className="site-visits-field-control"
              portalTarget={document.body}
            >
              {valueOptions.map((value) => (
                <MultiSelectOption key={value} label={value} value={value} />
              ))}
            </MultiSelect>
          </div>
        );
      })}
    </div>
  );
};

export default SectionConditionIndicatorFilter;
